import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css';
import '@/permission' // permission control
import 'lib-flexible/flexible'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vant);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

//
// request('https://api.uomg.com/api/rand.qinghua?format=json', res => {
//     console.log(res);
// }, err => {
//     console.log(err);
// })


//封装2
// request({
//     url: "rand.qinghua?format=json",
//     success: res => {
//         console.log(res);
//     },
//     fail: err => {
//         console.log(err);
//     }
//
// })
//封装3
// request({
//     url: 'getAllStudent'
// }).then(res => {
//     console.log(res);
// })
//封装4
// request({
//     url: 'getAllStudent'
// }).then(res => {
//     console.log(res);
// })